/* Company size from Companies House (the kind of accounts a company files).
 * sizeBucket mirrors system/server/lib/searchFilters.js — CHANGE ONE, CHANGE
 * THE OTHER (the release digest applies saved size filters server-side). */

export const SIZE_OPTIONS = [
    { key: 'micro', label: 'Micro', hint: 'Turnover up to about £1m' },
    { key: 'small', label: 'Small', hint: 'Up to about £15m' },
    { key: 'medium', label: 'Medium', hint: '£15m–£54m' },
    { key: 'large', label: 'Large', hint: 'Over about £54m, or part of a large group' },
    { key: 'new', label: 'New company', hint: 'Formed recently — no accounts filed yet' },
];
const OFFERED = new Set(SIZE_OPTIONS.map((o) => o.key));

// A stored/saved selection with anything we no longer offer removed.
export const offeredSizes = (sizeBands) => (sizeBands || []).filter((k) => OFFERED.has(k));

export const sizeBucket = (band) => {
    if (band === 'group') return 'large';
    if (['micro', 'small', 'medium', 'large', 'new'].includes(band)) return band;
    return 'none';
};

// Short label for a chip, or null when we have nothing to say.
export const sizeLabel = (company) => {
    if (!company) return null;
    const bucket = sizeBucket(company.size_band);
    if (bucket === 'none') return null;
    return SIZE_OPTIONS.find((o) => o.key === bucket)?.label || null;
};

// Only sizes we still offer count — an old saved "none" (Not on Companies
// House, removed 2026-09-29) is ignored rather than filtering invisibly.
export const matchesSize = (trader, sizeBands) => {
    const chosen = (sizeBands || []).filter((k) => OFFERED.has(k));
    return !chosen.length || chosen.includes(sizeBucket(trader.company?.size_band));
};
